import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface AdsPropertyGroupingObject {
  id: number;
  slug: string;
  titleEn: string;
  titleAr: string;
  icon: string;
  sort: number;
  isActive: boolean;
}

export interface AdsPropertyGroupingsListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  adsPropertyGroupings: Array<AdsPropertyGroupingObject>;
  errors: unknown;
}

@Module
export default class AdsPropertyGroupingModule
  extends VuexModule
  implements AdsPropertyGroupingsListInfo
{
  adsPropertyGroupings = [] as Array<AdsPropertyGroupingObject>;
  listDdlAdsPropertyGroupings = [] as Array<AdsPropertyGroupingObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get Ads Property Groupings list
   * @returns Array<AdsPropertyGroupingObject>
   */
  get adsPropertyGroupingsList(): Array<AdsPropertyGroupingObject> {
    return this.adsPropertyGroupings;
  }

  /**
   * Get all none ive Ads Property Groupings list
   * @returns Array<AdsPropertyGroupingObject>
   */
  get allListAdsPropertyGroupings(): Array<AdsPropertyGroupingObject> {
    return this.listDdlAdsPropertyGroupings;
  }

  /**
   * Get total items
   * @returns number
   */
  get adsPropertyGroupingsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_ADS_PROPERTY_GROUPINGS](data) {
    this.adsPropertyGroupings = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ADS_PROPERTY_GROUPING_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.SET_ALL_ADS_PROPERTY_GROUPINGS](data) {
    this.listDdlAdsPropertyGroupings = data.data;
  }

  @Mutation
  [Mutations.RESET_ADS_PROPERTY_GROUPINGS_LIST]() {
    this.adsPropertyGroupings = [] as Array<AdsPropertyGroupingObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_ADS_PROPERTY_GROUPINGS_STORE]() {
    this.context.commit(Mutations.RESET_ADS_PROPERTY_GROUPINGS_LIST);
  }

  @Action
  [Actions.CREATE_ADS_PROPERTY_GROUPING](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/ads-property-grouping', data)
      .then(({ data }) => {
        this.context.commit(Mutations.RESET_ADS_PROPERTY_GROUPINGS_LIST);
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_ADS_PROPERTY_GROUPING](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/ads-property-grouping', id)
      .then(() => {
        this.context.commit(Mutations.RESET_ADS_PROPERTY_GROUPINGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_ADS_PROPERTY_GROUPING]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/ads-property-grouping', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_ADS_PROPERTY_GROUPINGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_ADS_PROPERTY_GROUPING_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_ADS_PROPERTY_GROUPING_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_ADS_PROPERTY_GROUPING](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/ads-property-grouping', id);
  }

  @Action
  [Actions.GET_ADS_PROPERTY_GROUPINGS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/ads-property-grouping', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ADS_PROPERTY_GROUPINGS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.UPLOAD_ADS_PROPERTY_GROUPING_ICON]({ data, groupingId }) {
    ApiService.setAuthorizationHeader();
    ApiService.setMultipartHeader();
    return ApiService.post(
      `/ads-property-grouping/uploadIcon/${groupingId}`,
      data
    )
      .then(({ data }) => {
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
}
